import { $geoHttp } from '@/utils/https';

export const EU_LANGUAGES = [
  {
    name: 'Czech',
    urlPrefix: 'cz',
    countyCode: 'CZ'
  },
  {
    name: 'English',
    urlPrefix: 'en',
    countyCode: null
  },
  {
    name: 'Russian',
    urlPrefix: 'ru',
    countyCode: 'RU'
  },
  {
    name: 'Bulgarian',
    urlPrefix: 'bg',
    countyCode: 'BG'
  },
  {
    name: 'Danish',
    urlPrefix: 'da',
    countyCode: 'DK'
  },
  {
    name: 'German',
    urlPrefix: 'de',
    countyCode: 'DE'
  },
  {
    name: 'Greek',
    urlPrefix: 'el',
    countyCode: 'GR'
  },
  {
    name: 'Spanish',
    urlPrefix: 'es',
    countyCode: 'ES'
  },
  {
    name: 'Estonian',
    urlPrefix: 'et',
    countyCode: 'ES'
  },
  {
    name: 'Finnish',
    urlPrefix: 'fi',
    countyCode: 'FI'
  },
  {
    name: 'French',
    urlPrefix: 'fr',
    countyCode: 'FR'
  },
  {
    name: 'Irish',
    urlPrefix: 'ga',
    countyCode: 'IE'
  },
  {
    name: 'Croatian',
    urlPrefix: 'hr',
    countyCode: 'HR'
  },
  {
    name: 'Hungarian',
    urlPrefix: 'hu',
    countyCode: 'HU'
  },
  {
    name: 'Italian',
    urlPrefix: 'it',
    countyCode: 'IT'
  },
  {
    name: 'Luxembourgish',
    urlPrefix: 'lb',
    countyCode: 'LU'
  },
  {
    name: 'Lithuanian',
    urlPrefix: 'lt',
    countyCode: 'LT'
  },
  {
    name: 'Latvian',
    urlPrefix: 'lv',
    countyCode: 'LV'
  },
  {
    name: 'Maltese',
    urlPrefix: 'mt',
    countyCode: 'MT'
  },
  {
    name: 'Dutch',
    urlPrefix: 'nl',
    countyCode: 'NL'
  },
  {
    name: 'Polish',
    urlPrefix: 'pl',
    countyCode: 'PL'
  },
  {
    name: 'Portuguese',
    urlPrefix: 'pt',
    countyCode: 'PT'
  },
  {
    name: 'Romanian',
    urlPrefix: 'ro',
    countyCode: 'RO'
  },
  {
    name: 'Slovak',
    urlPrefix: 'sk',
    countyCode: 'SK'
  },
  {
    name: 'Slovenian',
    urlPrefix: 'sl',
    countyCode: 'SI'
  },
  {
    name: 'Swedish',
    urlPrefix: 'sv',
    countyCode: 'SE'
  },
  {
    name: 'Turkish',
    urlPrefix: 'tr',
    countyCode: 'TR'
  }
];

export const tryGetUserGeolocation = () => {
  return new Promise((resolve) => {
    // if (!navigator.geolocation) {
    //   console.log('Geolocation is not supported by your browser.');
    //   resolve(null);
    // }
    //
    // navigator.geolocation.getCurrentPosition(
    //   (position) => {
    //     let { latitude, longitude } = position.coords;
    // console.log('Coords', { latitude, longitude });
    $geoHttp
      .get('/json/')
      .then((result) => {
        resolve(result.data);
      })
      .catch(() => {
        resolve(null);
      });
    //     },
    //     (err) => {
    //       resolve(null);
    //       console.log('Error getting location: ' + err.message);
    //     }
    //   );
  });
};
